export { TabsController } from './TabsController';
export type { TabsControllerProps } from './TabsController';

export { Tabs } from './Tabs';
export type { TabsProps } from './Tabs';

export { TabItem } from './TabItem';
export type { TabItemProps } from './TabItem';
